export default "__VITE_ASSET__DR9zq2td__"